import { viemNetworkIdByChainId } from '@shapeshiftoss/contracts';
import { bn, convertDecimalPercentageToBasisPoints } from '@shapeshiftoss/utils';
import { Err, Ok } from '@sniptt/monads';
import { getTreasuryAddressFromChainId } from '../../utils/helpers/helpers';
import { assetIdToZrxToken } from './helpers/helpers';
import { zrxServiceFactory } from './zrxService';
const fetchFromZrx = async ({ quoteOrRate, buyAsset, sellAsset, sellAmountIncludingProtocolFeesCryptoBaseUnit, sellAddress, affiliateBps, slippageTolerancePercentageDecimal, zrxBaseUrl, }) => {
    const zrxService = zrxServiceFactory({ baseUrl: zrxBaseUrl });
    const maybeTreasuryAddress = (() => {
        try {
            return getTreasuryAddressFromChainId(buyAsset.chainId);
        }
        catch (err) { }
    })();
    // Rates are gotten using ZRX /swap/permit2/price endpoint
    const endpoint = quoteOrRate === 'quote' ? 'quote' : 'price';
    // https://0x.org/docs/api#tag/Swap/operation/swap::permit2::getPrice
    // https://0x.org/docs/api#tag/Swap/operation/swap::permit2::getQuote
    const maybeZrxPriceResponse = await zrxService.get(`/swap/permit2/${endpoint}`, {
        params: {
            chainId: viemNetworkIdByChainId[sellAsset.chainId],
            buyToken: assetIdToZrxToken(buyAsset.assetId),
            sellToken: assetIdToZrxToken(sellAsset.assetId),
            sellAmount: sellAmountIncludingProtocolFeesCryptoBaseUnit,
            taker: sellAddress,
            swapFeeBps: bn(affiliateBps).toNumber(),
            swapFeeToken: assetIdToZrxToken(buyAsset.assetId),
            slippageBps: convertDecimalPercentageToBasisPoints(slippageTolerancePercentageDecimal).toNumber(),
            swapFeeRecipient: maybeTreasuryAddress,
            feeRecipientTradeSurplus: maybeTreasuryAddress, // Where trade surplus is sent
        },
    });
    if (maybeZrxPriceResponse.isErr()) {
        return Err(maybeZrxPriceResponse.unwrapErr());
    }
    return Ok(maybeZrxPriceResponse.unwrap().data);
};
export const fetchZrxPrice = (args) => {
    return fetchFromZrx({
        quoteOrRate: 'rate',
        ...args,
    });
};
export const fetchZrxQuote = (args) => {
    return fetchFromZrx({
        quoteOrRate: 'quote',
        ...args,
    });
};
